<template>
  <div class="kydt">
  </div>
</template>
<script>

export default {
  components: {
    
  },
  data() {
    return {
      
    }
  },
  created() {
    this.$router.push({path:'homeIndex'})
  },
  methods: {
    
  },
  mounted() {
   
  },
  beforeDestroy() {
     
    },
  watch: { // 监听，当路由发生变化的时候执行
     
  }
};
</script>

<style lang="less" scoped>

</style>